enum ArtworkTypes {
    NoArtwork = 0,
    UploadArtwork = 1,
    SelectArtwork = 2,
    SelectORUploadArtwork = 3,
    PredefinedArtwork = 4,
    SocialArtwork = 5,
}
export default ArtworkTypes;